<template>
  <div class="relative flex flex-col items-center group">
    <slot name="buttonContent"></slot>
    <div class="absolute flex-col items-center hidden mb-2 bottom-full group-hover:flex">
      <span
        class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black rounded shadow-lg">
        {{ tooltipText }}
      </span>
      <div class="w-3 h-3 -mt-2 rotate-45 bg-black"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  tooltipText: string;
}>();
</script>
